import { Spin } from 'antd';
import clsx from 'clsx';
import ConditionalRender from '../ConditionalRender';
import { StepperFooterContext } from './types';
import styles from './StepperFormModal.module.scss';

interface StepperFooterProps<TStepId extends string> extends StepperFooterContext<TStepId> {
  backLabel: string;
  nextLabel: string;
  hideBack?: boolean;
}

const StepperFooter = <TStepId extends string>({
  isFirstStep,
  isLastStep,
  isSubmitting,
  goBack,
  goNext,
  backLabel,
  nextLabel,
  hideBack,
}: StepperFooterProps<TStepId>) => (
  <div className={styles.footer}>
    <ConditionalRender visible={!hideBack && !isFirstStep}>
      <button type="button" className={clsx(styles.footerButton, styles.backButton)} onClick={goBack} disabled={isSubmitting}>
        <span className={clsx(styles.caret, styles.caretBack)} aria-hidden />
        {backLabel}
      </button>
    </ConditionalRender>
    <button type="button" className={clsx(styles.footerButton, styles.nextButton)} onClick={goNext} disabled={isSubmitting}>
      {nextLabel}
      <ConditionalRender visible={isLastStep && isSubmitting} fallback={<span className={clsx(styles.caret, styles.caretNext)} aria-hidden />}>
        <Spin size="small" />
      </ConditionalRender>
    </button>
  </div>
);

export default StepperFooter;
